import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import { Job } from '../model/job.model';

@Injectable({ providedIn: 'root' })
export class ScheduleService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    create(job: Job): Observable<Job | null> {
        return this._http.post<Job | null>(
            `${this._appConfig.API_ENDPOINTS.REPORT}/schedule/jobs`,
            job,
        );
    }
}
